import React, {useContext} from 'react';
import {Redirect} from 'react-router-dom';
import {TabbedOverviewPage, ReadinessSolutionOverviewSection} from '../components/OverviewSections.comp';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

// P1 only in the sidebar (see NationalDashboardList). /overview redirects here
// for every plan, so a P0 user is sent on to their first intro page.
const AboutReadinessSolutionPage = () => {
    const {authUser} = useContext(AuthContext);
    if (getPlanStage(authUser) === 'P0') {
        return <Redirect to="/dq_pro/national-dashboard/overview/about-assessment"/>;
    }
    return (
        <TabbedOverviewPage
            skipNoDataGate
            tabs={[
                {
                    label: 'Child Online Safety (COS) Readiness Solution',
                    content: <ReadinessSolutionOverviewSection/>,
                },
            ]}
        />
    );
};

export default AboutReadinessSolutionPage;
